import { useCallback, useState } from 'react';

export function useRefSetters() {
  const [itemContainerRef, setItemContainerRef] = useState(null);
  const [sectionContainerRef, setSectionContainerRef] = useState(null);

  const sectionContainerRefSetter = useCallback((node) => {
    if (!node) return null;
    setSectionContainerRef(node);
  }, []);
  const itemsContainerRefSetter = useCallback((node) => {
    if (!node) return null;
    setItemContainerRef(node);
  }, []);

  return {
    sectionContainerRefSetter,
    itemsContainerRefSetter,
    sectionContainerRef,
    itemContainerRef,
  };
}
